var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExpandIcon = function SvgExpandIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 132.292 132.292",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.261,
    transform: "translate(.548 -.805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.343 21.46l-.077 92.375c-.338 10.477 7.875 18.654 19.913 18.356l92.155.109c12.307.06 18.287-6.483 18.607-18.797l-.027-30.245c.138-13.017-18.672-12.84-18.548-.214l-.017 30.5-92.385-.055.22-92.465H50.28c14.653.174 15.403-19.258.257-19.356l-30.427.137C6.571 1.626.117 7.699.343 21.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.945 1.602c-12.96.03-12.67 20.097 0 20.067H99.28L51.753 68.403c-11.153 10.72 2.222 24.04 13.465 13.994l47.015-48.06-.342 14.962c-.034 12.04 18.766 11.549 18.544.203l.04-37.714c.12-6.46-3.586-10.072-10.978-10.03z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExpandIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/expand-icon.da1c524f4bdb9ca362167a410f4358e4.svg";